import React from "react";

function UXDesign() {
  return <div>UXDesign</div>;
}

export default UXDesign;
